import { getGlobalFeatureFlagsCacheIfFresh } from '../feature-flags/globalFeatureFlagsService';

function envOverride(): boolean | null {
  const v = process.env.EXPO_PUBLIC_BILLING_ENABLED;
  if (v === 'false') return false;
  if (v === 'true') return true;
  return null;
}

/** Billing/subscriptions are opt-in. Default = free mode (Vuelto gratis). */
export function isBillingEnabled(): boolean {
  const env = envOverride();
  if (env !== null) return env;
  const flags = getGlobalFeatureFlagsCacheIfFresh();
  if (!flags) return false;
  return flags.billing_enabled === true;
}
